// Minimal lotus line-icon echoing the ROYALE logo
export const Lotus = ({ className = "", strokeWidth = 1 }) => (
  <svg
    viewBox="0 0 64 48"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      <path d="M32 6c3.2 4.8 4.8 9.4 4.8 14.4 0 5.6-2 10-4.8 13.2-2.8-3.2-4.8-7.6-4.8-13.2C27.2 15.4 28.8 10.8 32 6Z" />
      <path d="M32 33.6c-3-3.4-7.4-7-12.4-8 .2 5 2.6 9.4 6.4 12 2 1.4 4.2 2.2 6 2.6" />
      <path d="M32 33.6c3-3.4 7.4-7 12.4-8-.2 5-2.6 9.4-6.4 12-2 1.4-4.2 2.2-6 2.6" />
      <path d="M32 34c-5-2.6-11.2-3.8-17.6-2.6 2 4.6 6 8 10.8 9.2 2.6.6 5 .6 6.8.4" />
      <path d="M32 34c5-2.6 11.2-3.8 17.6-2.6-2 4.6-6 8-10.8 9.2-2.6.6-5 .6-6.8.4" />
    </g>
  </svg>
);
